export default __webpack_public_path__ + "static/media/CheckIn-SelectDateIcon.24c97401.png";